import type { FieldErrors, UseFormRegister } from 'react-hook-form'

import clsx from 'clsx'
import { sanitizeFieldName } from '@/utils/sanitizedLabel'

type Props = {
	id: string
	label: string
	required: boolean
	formStyle: string
	colSpan?: string
	register: UseFormRegister<any>
	errors: FieldErrors
	className?: string
}

export default function Input({
	id,
	label,
	required,
	formStyle,
	colSpan = '1',
	register,
	errors,
	className,
}: Props) {
	const fieldName = sanitizeFieldName(label)

	return (
		<div
			className={clsx(
				'form-component',
				{
					'2': 'colSpan2',
				}[colSpan],
				className
			)}
		>
			<div
				className={clsx('form-element-container', formStyle === 'line' && 'line-style')}
				onClick={() => document.getElementById(id)?.focus()}
			>
				<input
					id={id}
					type="text"
					className="input"
					placeholder=""
					{...register(fieldName, {
						required: {
							value: required,
							message: `${label} is required`,
						},
					})}
				/>
			</div>
			<label htmlFor={id}>{`${label} ${required ? '*' : ''}`}</label>
			{errors[fieldName] && (
				<span className="mt-1 text-red-500">{errors[fieldName]?.message as string}</span>
			)}
		</div>
	)
}
